import { render, staticRenderFns } from "./WelcomeBagPacking.vue?vue&type=template&id=f7527884&scoped=true"
import script from "./WelcomeBagPacking.vue?vue&type=script&lang=js"
export * from "./WelcomeBagPacking.vue?vue&type=script&lang=js"
import style0 from "./WelcomeBagPacking.vue?vue&type=style&index=0&id=f7527884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7527884",
  null
  
)

export default component.exports